import {
    getOptionsForFeature,
    lazyCreateOrUpdateOptionsForFeature,
    OwsOptionsFeatureType,
    TranslationOptions,
} from 'owa-outlook-service-options';
import { mutatorAction } from 'satcheljs';

export default mutatorAction('addExcludedLanguage', function addExcludedLanguage(language: string) {
    const userOptions = getOptionsForFeature<TranslationOptions>(OwsOptionsFeatureType.Translation);

    userOptions.excludedLanguages.push(language);

    lazyCreateOrUpdateOptionsForFeature.importAndExecute(
        OwsOptionsFeatureType.Translation,
        userOptions
    );
});
